import { PropsWithChildren, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import { clx } from "../../utilities/clx";
import { AnimatePresence, motion } from "motion/react";

export const ExecutionDetails = ({
  open,
  children,
  onToggle,
  title,
  enableLimitedHeight,
  autoScroll,
}: PropsWithChildren<{
  open?: boolean;
  onToggle?: () => void;
  title: React.ReactNode;
  enableLimitedHeight?: boolean;
  autoScroll?: boolean;
}>) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (autoScroll && open && contentRef.current) {
      contentRef.current.scrollTo({
        top: contentRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [autoScroll, open, children]);

  return (
    <aside className={styles.container}>
      <header onClick={onToggle} className={styles.header}>
        {title} {open ? <CloseButton /> : <OpenButton />}
      </header>
      <AnimatePresence>
        {open && (
          <motion.main
            ref={contentRef}
            className={clx([
              styles.main,
              enableLimitedHeight && styles.limitedHeight,
            ])}
            exit={{ height: 0, padding: 0, paddingLeft: 0, opacity: 0 }}
            initial={{ height: 0, padding: 0, opacity: 0 }}
            animate={{ height: "auto", paddingLeft: 24, opacity: 1 }}
          >
            {<div>{children}</div>}
          </motion.main>
        )}
      </AnimatePresence>
    </aside>
  );
};

const CloseButton = () => {
  return (
    <button name="Close" aria-label="Close" className={styles.button}>
      ⏶
    </button>
  );
};

const OpenButton = () => {
  return (
    <button name="Open" aria-label="Open" className={styles.button}>
      ⏷
    </button>
  );
};
